import React from 'react';
import { Translate } from 'react-jhipster';

import { NavItem, NavLink, NavbarBrand } from 'reactstrap';
import { NavLink as Link } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Select, Space } from 'antd';

export const BrandIcon = props => (
  <div {...props} className="brand-icon">
    <img src="content/images/logo-jhipster.png" alt="Logo" />
  </div>
);

export const Brand = () => (
  <NavbarBrand tag={Link} to="/" className="brand-logo">
    <BrandIcon />
    <span className="brand-title">
      <Translate contentKey="global.title">Binoculars</Translate>
    </span>
    <span className="navbar-version">{VERSION}</span>
  </NavbarBrand>
);

export const Home = () => (
  <NavItem>
    <NavLink tag={Link} to="/" className="d-flex align-items-center">
      <FontAwesomeIcon icon="home" />
      <span>
        <Translate contentKey="global.menu.home">Home</Translate>
      </span>
    </NavLink>
  </NavItem>
);

export const InvoiceMenu = () => (
  <NavItem>
    <NavLink tag={Link} to="/invoices" className="d-flex align-items-center">
      <FontAwesomeIcon icon="file-text" />
      <span>
        <Translate contentKey="global.menu.invoice">Invoice</Translate>
      </span>
    </NavLink>
  </NavItem>
);

export const RevenueLink = () => (
  <NavItem>
    <NavLink tag={Link} to="/revenue" className="d-flex align-items-center">
      <FontAwesomeIcon icon="file-text" />
      <span>
        <Translate contentKey="global.menu.revenue">Revenue</Translate>
      </span>
    </NavLink>
  </NavItem>
);
